export const colors = {
  almostBlack: {
    DEFAULT: '#333333',
    300: '#878787',
  },
  bubblegum: {
    DEFAULT: '#F87FA3',
    50: '#FFE7EE',
    100: '#F7A8C0',
    300: '#F79AB6',
    500: '#F87FA3',
  },
  cariloop: {
    DEFAULT: '#F26529',
    400: '#F9B8A0',
    500: '#F26529',
  },
  emerald: {
    DEFAULT: '#03B3C3',
    50: '#E7F4F6',
    100: '#D0EAEC',
    300: '#A1D5DA',
    500: '#03B3C3',
    700: '#027C88',
  },
  facebookBlue: {
    DEFAULT: '#0866FF',
    300: '#3284F0',
    500: '#0866FF',
  },
  gray: {
    DEFAULT: '#707070',
    100: '#F5F5F5',
    300: '#E5E7EB',
    400: '#A6A5A5',
    500: '#707070',
  },
  honey: {
    DEFAULT: '#FFBF00',
    50: '#FFF5D7',
    300: '#FED763',
    400: '#FED664',
    500: '#FFBF00',
  },
  kinsideGreen: {
    DEFAULT: '#008066',
  },
  kiwi: {
    DEFAULT: '#ACDD4D',
    50: '#EDF8D3',
    300: '#BCE954',
    500: '#ACDD4D',
    700: '#6CC417',
  },
  raspberry: {
    DEFAULT: '#EA658D',
    300: '#E87798',
    400: '#E46B8D',
    500: '#EA658D',
  },
  ocean: {
    DEFAULT: '#0482C3',
    50: '#E2F6FF',
    500: '#0482C3',
    700: '#0D67AD',
  },
  sapphire: {
    DEFAULT: '#4649DF',
    50: '#DDE7E7',
    100: '#7BAEF0',
    300: '#91C0F1',
    500: '#4649DF',
    700: '#5A5CA5',
    900: '#4A4CB0',
  },
  summer: {
    DEFAULT: '#F58A77',
  },
  tangerine: {
    DEFAULT: '#FC5B41',
  },
  tansy: {
    DEFAULT: '#00A8FF',
    50: '#E7F0FD',
    100: '#BFE9FF',
    300: '#9BDDFF',
    500: '#00A8FF',
    600: '#046773',
    700: '#06515F',
    900: '#024568',
  },
  error: {
    DEFAULT: '#F7E9E9',
    500: '#D32F2F',
  },
  success: {
    DEFAULT: '#D4EDDA',
    500: '#2E7D32',
  },
  warning: {
    DEFAULT: '#FFF3CD',
    500: '#ED6C02',
  },
};

export const fontSize = {
  '2xs': ['.625rem', '1rem'],
};
